// @flow

import React from 'react';

export function UnpublishedVenueWarning() {
  return (
    <span>
      <i
        className="fa fa-exclamation-triangle m-icon-warning"
        title={__('search.venue_preview.published')}
      />{' '}
    </span>
  );
}

export function RestrictedVenueWarning() {
  return (
    <span>
      <i
        className="fa fa-eye m-icon-warning"
        title={__('search.venue_preview.restricted')}
      />{' '}
    </span>
  );
}
